// Stage Mail-1:連携 card ヘッダー用 Badge コンポーネント。
//
// 設定全体の status 4 値:
// - not_configured:DB に account 行が無い(連携未設定)
// - connected:is_active && has_*_password 全備 + 接続テスト connects
// - warning:is_active && 設定はあるが password 不備 / port / host などの
//   integrity チェック未通過
// - auth_failed:stored mode 接続テストで auth_failed が返った状態。
//   直近テスト結果があれば優先表示する。
//
// 設定ページの Mail-1 で使うが、Mail-4A / Stage 7 の status 拡張でも
// 再利用できるよう独立して utils に置く。

import React from "react";
import { CheckCircle2, AlertCircle, XCircle, CircleDashed } from "lucide-react";
import { Badge } from "../ui/Badge";

export type IntegrationStatus = "not_configured" | "connected" | "warning" | "auth_failed";

export interface IntegrationStatusBadgeProps {
  status: IntegrationStatus;
  /** 表示テキストを override したい場合に指定。 */
  label?: string;
}

const STATUS_LABEL: Record<IntegrationStatus, string> = {
  not_configured: "未設定",
  connected: "連携中",
  warning: "要確認",
  auth_failed: "認証失敗",
};

const STATUS_COLOR: Record<IntegrationStatus, "green" | "yellow" | "red" | "gray"> = {
  not_configured: "gray",
  connected: "green",
  warning: "yellow",
  auth_failed: "red",
};

const STATUS_ICON: Record<IntegrationStatus, React.ReactNode> = {
  not_configured: <CircleDashed size={11} />,
  connected: <CheckCircle2 size={11} />,
  warning: <AlertCircle size={11} />,
  auth_failed: <XCircle size={11} />,
};

export function IntegrationStatusBadge({ status, label }: IntegrationStatusBadgeProps) {
  return (
    <Badge color={STATUS_COLOR[status]} dot>
      {STATUS_ICON[status]} {label ?? STATUS_LABEL[status]}
    </Badge>
  );
}
